//@ts-check
var INTEGRATION_DATA_TYPE = {
  data: {
    dataKey: 'integration',
    url: '/backend/crm',
    itemUrl: '/backend/crm',
    createItemUrl: '/backend/crm',
    idKeyProp: 'Connection.Id',
    deleteItemUrl: '/backend/crm' // onBeforeRequest: (options, request) => {
    //   return {
    //     ...request,
    //   };
    // },

  },
  placeholders: {
    label: function label(data) {
      return data.Connection.ConnectionName;
    },
    type: function type() {
      return 'integration';
    },
    icon: function icon() {
      return 'integration';
    }
  }
};
export default INTEGRATION_DATA_TYPE;